// extracted by mini-css-extract-plugin
module.exports = {"top":"_Document_top__1b496","backLink":"_Document_backLink__2DwvO","wrapper":"_Document_wrapper__3F9uj","document":"_Document_document__3AgzN","info":"_Document_info__2V69i"};